module.exports = __webpack_public_path__ + "static/media/peda_under_tree.73273d74.gif";